module.exports = __webpack_public_path__ + "img/arrow-up-right-from-square.7d272bf1.svg";